import { render, staticRenderFns } from "./Webhook.vue?vue&type=template&id=dfaaba00&scoped=true&"
import script from "./Webhook.vue?vue&type=script&lang=js&"
export * from "./Webhook.vue?vue&type=script&lang=js&"
import style0 from "./Webhook.vue?vue&type=style&index=0&id=dfaaba00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaaba00",
  null
  
)

export default component.exports